import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-thermometer',
  templateUrl: './thermometer.component.html',
  styleUrls: ['./thermometer.component.css'],
})
export class ThermometerComponent implements OnChanges {
  @Input() value = 50; // 0 - 100
  @Input() height = 170;

  fluidHeight = 0;
  fluidY = 0;
  fluidColor = '#3498db';

  ticks = Array.from({ length: 11 }).map((_, i) => 190 - i * 15);

  ngOnChanges() {
    const maxHeight = 155;
    const h = (this.value / 100) * maxHeight;

    this.fluidHeight = h;
    this.fluidY = 190 - h;

    this.fluidColor = this.getColor(this.value);
  }

  getColor(v: number) {
    if (v < 25) return '#3498db'; // blue
    if (v < 50) return '#2ecc71'; // green
    if (v < 75) return '#f39c12'; // orange
    return '#e74c3c'; // red
  }
}
